import { render } from "./AdminTrackApprovedPaymentLiquidation.vue?vue&type=template&id=04c56757"
import script from "./AdminTrackApprovedPaymentLiquidation.vue?vue&type=script&lang=js"
export * from "./AdminTrackApprovedPaymentLiquidation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__